import { useLangQuery } from '@hooks/useLangQuery';

import { fetchFooter } from './footer.api';
import { QUERY_KEYS } from '../queries';

export const useFooterQuery = () =>
  useLangQuery({
    queryKey: QUERY_KEYS.footer,
    queryFn: fetchFooter,
    staleTime: 5 * 60 * 1000,
  });
